import { MLHelper, createGuid } from '@bimser/core';
import * as React from 'react';
import BCButton from '../BCButton';
import BCCollapse, { ICollapsePanelProps } from '../BCCollapse';
import { findMessage } from '../BCIntl';
import BCScrollbars from '../BCScrollbars';
import Styles from './assets/styles.scss';
const NotReachableIcon = require('./assets/not-reachable.svg');

export default class ErrorBoundary extends React.Component<
	{ mobile?: any; children?: React.ReactNode; showHomeBtn?: boolean },
	{ error: Error; errorInfo: { componentStack: string } }
> {
	constructor(props: any) {
		super(props);
		this.state = { error: null, errorInfo: null };
		this.getContent = this.getContent.bind(this);
		this.getCollapseItems = this.getCollapseItems.bind(this);
	}

	componentDidCatch(error: any, errorInfo: any) {
		console.error(error);
		this.setState({
			error: error,
			errorInfo: errorInfo
		});
	}

	getCollapseItems(componentStack: string): ICollapsePanelProps['items'] {
		return [
			{
				children: this.getContent(componentStack),
				key: '0',
				label: findMessage.get('102073')
			}
		];
	}

	getContent(componentStack: string) {
		return (
			<BCScrollbars cssClass={Styles.scrollbars}>
				<div className={Styles.details}>
					{this.state?.error?.stack + '\n' + componentStack}
				</div>
			</BCScrollbars>
		);
	}

	render() {
		if (this.state.errorInfo) {
			const message: any = {
				typeName: 'ShowMessageAction',
				dialogType: 'Popup',
				alertType: 'didCatch',
				id: createGuid(),
				messages: findMessage.get('102284'),
				name: findMessage.get('102284'),
				enabled: true
			};
			this.props.mobile?.MobileView.mobileClientSideMessages([message]);

			const errorTime = new Intl.DateTimeFormat(`${MLHelper.currentLanguage.culture}`, {
				dateStyle: 'long',
				timeStyle: 'medium'
			}).format(Date.now());

			return (
				<div className={Styles.errorBoundary}>
					<div className={Styles.undefinedErrorContainer}>
						<div className={Styles.notReachableStyleContainerStyle}>
							<img
								src={NotReachableIcon.default}
								className={Styles.notReachableStyle}
							/>
						</div>
						<div className={Styles.contentContainerStyle}>
							<div className={Styles.undefinedErrorMessageContainerStyle}>
								<p className={Styles.undefinedErrorMessageFirstStyle}>
									{findMessage.get('102284')}
								</p>
								<p className={Styles.undefinedErrorMessageSecondStyle}>
									{findMessage.get('102639')}
								</p>
								<p className={Styles.undefinedErrorMessageTimeStyle}>{errorTime}</p>
								{this.props.showHomeBtn && (
									<BCButton
										onClick={() => location.reload()}
										type="primary"
									>
										{findMessage.get('103030')}
									</BCButton>
								)}
								<BCCollapse
									classNames={[Styles.collapse]}
									items={this.getCollapseItems(
										this.state.errorInfo.componentStack
									)}
								/>
							</div>
						</div>
					</div>
				</div>
			);
		}

		return this.props.children;
	}
}
